import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import CommentBoxAvatar from '../../../../lego/CommentBoxAvatar';
import CommentBoxEditor from '../../../../lego/CommentBoxEditor';
import CommentBoxLayout from '../../../../layouts/CommentBoxLayout';
import CommentSuggestions from '../../lego/CommentSuggestions';
const EditorView = (_param)=>{
    var { suggestions, maxVisible, onSuggestionSelect } = _param, rest = _object_without_properties(_param, [
        "suggestions",
        "maxVisible",
        "onSuggestionSelect"
    ]);
    return /*#__PURE__*/ React.createElement(CommentBoxLayout, {
        above: /*#__PURE__*/ React.createElement(CommentSuggestions, {
            suggestions: suggestions,
            maxVisible: maxVisible,
            onSelect: onSuggestionSelect
        }),
        avatar: /*#__PURE__*/ React.createElement(CommentBoxAvatar, null),
        content: /*#__PURE__*/ React.createElement(CommentBoxEditor, rest)
    });
};
EditorView.displayName = 'EditorView';
export default EditorView;

//# sourceMappingURL=EditorView.js.map